var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCaretRegular = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.16132 14.9083C4.45412 15.7165 5.0281 16.9814 6.10204 16.9814H17.8983C18.9722 16.9814 19.5462 15.7165 18.839 14.9083L13.3172 8.59765C12.6199 7.80083 11.3804 7.80083 10.6831 8.59765L5.16132 14.9083ZM6.65298 15.4814L11.812 9.58541C11.9116 9.47158 12.0887 9.47158 12.1883 9.58541L17.3473 15.4814H6.65298Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCaretRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/caret-regular.bbd3ba37.svg";
export { ForwardRef as ReactComponent };